import { IconPlus, IconTrash } from '../../../common/icons';

// Repeatable farm sub-form used inside the create-client flow. Each farm will
// be created (queued) against POST /admin/farms with owner_id = the new client.
// Errors are keyed by the row's local id.

export default function FarmRows({ farms, onAdd, onRemove, onField, errors, disabled }) {
    return (
        <section className="client-form__section">
            <div className="client-form__section-head">
                <div>
                    <h2 className="client-form__section-title">Fincas del cliente</h2>
                    <p className="client-form__section-hint">
                        Opcional. Se crearán a nombre del cliente al guardar.
                    </p>
                </div>
                <button
                    type="button"
                    className="client-form__add-farm"
                    onClick={onAdd}
                    disabled={disabled}
                >
                    <IconPlus />
                    <span>Agregar finca</span>
                </button>
            </div>

            {farms.length === 0 ? (
                <p className="client-form__empty">No agregaste fincas todavía.</p>
            ) : (
                <ul className="farm-rows">
                    {farms.map((farm, i) => {
                        const err = errors[farm.key] || {};
                        return (
                            <li key={farm.key} className="farm-row">
                                <div className="farm-row__index">{i + 1}</div>

                                <div className="farm-row__fields">
                                    <label className="client-form__field farm-row__name">
                                        <span className="client-form__label">Nombre de la finca</span>
                                        <input
                                            type="text"
                                            value={farm.name}
                                            onChange={(e) => onField(farm.key, 'name', e.target.value)}
                                            maxLength={120}
                                            disabled={disabled}
                                            placeholder="Ej. La Esperanza"
                                            aria-invalid={!!err.name}
                                        />
                                        {err.name && <span className="client-form__error" role="alert">{err.name}</span>}
                                    </label>

                                    <label className="client-form__field farm-row__size">
                                        <span className="client-form__label">Tamaño (ha)</span>
                                        <input
                                            type="number"
                                            min="0"
                                            step="any"
                                            value={farm.size}
                                            onChange={(e) => onField(farm.key, 'size', e.target.value)}
                                            disabled={disabled}
                                            placeholder="Opcional"
                                            aria-invalid={!!err.size}
                                        />
                                        {err.size && <span className="client-form__error" role="alert">{err.size}</span>}
                                    </label>

                                    <label className="client-form__field farm-row__address">
                                        <span className="client-form__label">Ubicación</span>
                                        <input
                                            type="text"
                                            value={farm.address}
                                            onChange={(e) => onField(farm.key, 'address', e.target.value)}
                                            disabled={disabled}
                                            placeholder="Dirección o vereda (opcional)"
                                        />
                                    </label>
                                </div>

                                <button
                                    type="button"
                                    className="farm-row__remove"
                                    onClick={() => onRemove(farm.key)}
                                    disabled={disabled}
                                    aria-label="Quitar finca"
                                    title="Quitar"
                                >
                                    <IconTrash />
                                </button>
                            </li>
                        );
                    })}
                </ul>
            )}
        </section>
    );
}
